<header>
  <skip-nav></skip-nav>
  @if (!fnolCheck && !auth.countryCheck() && country !== 'singapore'
  && country !== 'us' && country !== 'au' && country !== 'nz' && !FnolService.getPagestatus()) {
  <axis-navbar
    ariaLabel="Secondary Menu"
    *ngIf="screenSize !== 'mobile' "
  >
    <axis-navbar-logo>
      <img
        alt="AIG logo"
        src="assets/images/logos/aig-logo-blue.svg"
      />
      <span class="sr-only">American International Group, Inc.</span>
    </axis-navbar-logo>
    <axis-navbar-app-title>{{title}}</axis-navbar-app-title>
    <axis-navbar-right>
      <ul class="axis-nav">
        @if (axisNavbarRight) {
        <li class="axis-navbar-item">
          <button
            axis-button
            class="kind-link"
            (click)="modalConfirm.openModal('Dashboard')"
          >
            Dashboard
          </button>
        </li>
        }
        @if (claimDashboard) {
        <li class="axis-navbar-item">
          <button
            axis-button
            class="kind-link"
            routerLink="/dashboard"
          >
            Dashboard
          </button>
        </li>
        }
        @if (noNavBar) {
        <li class="axis-navbar-item">
          <!-- <app-menu
            (selected)="goFlyoutNJP($event)"
            [settings]="menuMoreItemNJP"
          ></app-menu> -->
          <axis-dropdown
            class="kind-icon align-right"
            icon="user_circle"
            templateClasses="axis-navbar-dropdown"
          >
            @if (circlePerson) {
            <axis-dropdown-list routerLink="/my-profile">My Profile
            </axis-dropdown-list>
            }
            <axis-dropdown-list (click)="modalContact.openModal()">
              Contact Us
            </axis-dropdown-list>
            @if (circlePerson) {
            <axis-dropdown-list routerLink="/login/logout">Sign Out
            </axis-dropdown-list>
            }
            @if (axisNavbarRightPassword) {
            <axis-dropdown-list (click)="modalConfirm.openModal('SignOut')">Sign Out
            </axis-dropdown-list>
            }
          </axis-dropdown>
        </li>
        }
      </ul>
    </axis-navbar-right>
  </axis-navbar>
  <nav
    class="axis-navbar-mobile"
    *ngIf="screenSize !== 'desktop'"
    [ngClass]="{'open':navbarOpen}"
  >
    <div
      class="axis-mobile-overlay"
      (click)="closeOverlay()"
    ></div>
    <div class="axis-mobile-header">
      <div class="axis-navbar-title">
        <axis-navbar-logo>
          <img
            alt="AIG logo"
            src="assets/images/logos/aig-logo-blue.svg"
          />
          <span class="sr-only">American International Group, Inc.</span>
        </axis-navbar-logo>
        @if (getHeaderLanguage() === 'no') {
        <axis-navbar-app-title>Skademelding</axis-navbar-app-title>
        }
        @if (getHeaderLanguage() === 'en') {
        <axis-navbar-app-title>Claims Digital Portal</axis-navbar-app-title>
        }
        @if (getHeaderLanguage() === 'jp') {
        <axis-navbar-app-title i18n="@@appTitle">デジタル保険金請求</axis-navbar-app-title>
        }
      </div>

      @if (country === 'jp' && getHeaderLanguage() === 'jp') {
      <button
        aria-controls="mobile-nav"
        aria-label="Menu"
        [attr.aria-expanded]="navbarOpen"
        axis-button
        (click)="toggleNavbar()"
        class="kind-icon"
      >
        <axis-icon icon="menu"></axis-icon>
      </button>
      }
    </div>
    <div
      class="axis-navbar-mobile-container"
      [ngClass]="{ open: navbarOpen }"
    >

      <ng-template [ngTemplateOutlet]="templateCloseVar"></ng-template>

      <div class="axis-navbar-mobile-menu">
        <ul class="axis-nav">
          @if (axisNavbarRight) {
          <li class="axis-navbar-item">
            <button
              axis-button
              class="kind-link"
              (click)="modalConfirm.openModal('Dashboard')"
            >
              Dashboard
            </button>
          </li>
          }
          @if (claimDashboard) {
          <li class="axis-navbar-item">
            <button
              axis-button
              class="kind-link"
              routerLink="/dashboard"
            >
              Dashboard
            </button>
          </li>
          }
          @if (circlePerson) {
          <li class="axis-navbar-item">
            <button
              axis-button
              class="kind-link"
              routerLink="/my-profile"
            >
              My Profile
            </button>
          </li>
          }
          @if (circlePerson) {
          <li class="axis-navbar-item">
            <button
              axis-button
              class="kind-link"
              routerLink="/login/logout"
            >
              Sign Out
            </button>
          </li>
          }
          @if (axisNavbarRightPassword) {
          <li class="axis-navbar-item">
            <button
              axis-button
              class="kind-link"
              (click)="modalConfirm.openModal('SignOut')"
            >
              Sign Out
            </button>
          </li>
          }
        </ul>
      </div>
    </div>
  </nav>

  }
  @if (auth.countryCheck() && !FnolService.getPagestatus() && this.isAuthenticated) {
  <axis-navbar
    ariaLabel="Secondary Menu"
    *ngIf="screenSize !== 'mobile' "
  >
    <axis-navbar-logo>
      <img
        alt="AIG logo"
        src="assets/images/logos/aig-logo-blue.svg"
      />
      <span class="sr-only">American International Group, Inc.</span>
    </axis-navbar-logo>
    <axis-navbar-app-title i18n="@@appTitle">デジタル保険金請求</axis-navbar-app-title>
    @if (this.isAuthenticated) {
    <axis-navbar-right>
      <ng-template [ngTemplateOutlet]="navbarRight"></ng-template>
      <!-- <ul class="axis-nav">
              <li
                class="axis-navbar-item"
                [ngClass]="{ active: selectedItem === 'myClaim' }"
                >
                <a
                  axis-button
                  i18n="@@myClaim"
                  class="kind-link"
                  (click)="goto()"
                  >
            お客さまのご請求内容
                </a>
              </li>
              <li
                class="axis-navbar-item"
                [ngClass]="{ active: selectedItem === 'myPolicy' }"
                >
                <a
                  axis-button
                  i18n="@@myPolicy"
                  class="kind-link"
                  [routerLink]="[partialRouterLink, 'policies']"
                  >
            お客さまのご契約内容
                </a>
              </li>
               <li class="axis-navbar-item">
          <app-menu
            (selected)="goFlyout($event)"
            [settings]="menuMoreItem"
          ></app-menu>
        </li>
          </ul> -->
    </axis-navbar-right>
    }
  </axis-navbar>
  <nav
    class="axis-navbar-mobile"
    *ngIf="screenSize !== 'desktop'"
    [ngClass]="{'open':navbarOpen}"
  >
    <div
      class="axis-mobile-overlay"
      (click)="closeOverlay()"
    ></div>
    <div class="axis-mobile-header">
      <div class="axis-navbar-title">
        <axis-navbar-logo>
          <img
            alt="AIG logo"
            src="assets/images/logos/aig-logo-blue.svg"
          />
          <span class="sr-only">American International Group, Inc.</span>
        </axis-navbar-logo>
        @if (language === 'jp') {
        <axis-navbar-app-title i18n="@@appTitle">デジタル保険金請求</axis-navbar-app-title>
        }
        @if (language !== 'jp') {
        <axis-navbar-app-title i18n="@@appTitle">デジタル保険金請求</axis-navbar-app-title>
        }
      </div>

      @if (this.isAuthenticated) {
      <button
        aria-controls="mobile-nav"
        aria-label="Menu"
        [attr.aria-expanded]="navbarOpen"
        axis-button
        (click)="toggleNavbar()"
        class="kind-icon"
      >
        <axis-icon icon="menu"></axis-icon>
      </button>
      }
    </div>
    <div
      class="axis-navbar-mobile-container"
      id="mobile-nav"
    >
      <ng-template [ngTemplateOutlet]="templateCloseVar"></ng-template>
      <div class="axis-navbar-mobile-menu">
        <ng-template [ngTemplateOutlet]="navbarRight"></ng-template>
      </div>
    </div>
  </nav>

  <ng-template #navbarRight>
    <ul class="axis-nav">
      <li
        class="axis-navbar-item"
        [ngClass]="{ active: selectedItem === 'myClaim' }"
      >
        <a
          axis-button
          (click)="closeOverlay();goto()"
          i18n="@@myClaim"
          class="kind-link"
          [routerLink]="[partialRouterLink,'dashboard']"
        >
          お客さまのご請求内容
        </a>

      </li>
      <li
        class="axis-navbar-item"
        [ngClass]="{ active: selectedItem === 'myPolicy' }"
      >
        <a
          axis-button
          i18n="@@myPolicy"
          (click)="closeOverlay()"
          class="kind-link"
          [routerLink]="[partialRouterLink, 'policies']"
        >
          お客さまのご契約内容
        </a>

      </li>
      <!-- @if (axisNavbarRight) {
      <li class="axis-navbar-item">
        <a axis-button class="kind-link" (click)="modalConfirm.openModal('Dashboard')">
          Dashboard
        </a>
      </li>
      }
      @if (claimDashboard) {
      <li class="axis-navbar-item">
        <a axis-button class="kind-link" routerLink="/dashboard">
          Dashboard
        </a>
      </li>
      } -->
      @if (circlePerson) {
      <li class="axis-navbar-item">
        <app-menu
          (selected)="goFlyout($event)"
          [settings]="menuMoreItem"
        ></app-menu>
      </li>
      <!--
           <li class="axis-list-group-item">
            <button axis-button class="kind-link" (click)="closeOverlay()" [routerLink]="[partialRouterLink, 'profile']"
              >
              お客さま情報
            </button>
          </li>
          <li class="axis-list-group-item">
            <button axis-button  (click)="openTab()" class="kind-link">
              ヘルプ
            </button>
          </li>
          <li class="axis-list-group-item">
            <button axis-button class="kind-link" (click)="signout()" >
              サインアウト
            </button>
          </li> -->
      }
      @if (axisNavbarRightPassword) {
      <li class="axis-list-group-item">
        <button
          axis-button
          class="kind-link"
          (click)="modalConfirm.openModal('SignOut')"
        >
          Sign Out
        </button>
      </li>
      }
    </ul>
  </ng-template>
  }
  @if (fnolCheck && !auth.countryCheck() && !FnolService.getPagestatus()) {
  <axis-navbar [ngClass]="{ singapore_nav_header: country === 'singapore' }">
    <axis-navbar-logo>
      <img
        alt="AIG logo"
        src="assets/images/logos/aig-logo-blue.svg"
      />
      <span class="sr-only">American International Group, Inc.</span>
    </axis-navbar-logo>
    @if (country !== 'singapore') {
    <axis-navbar-app-title>Claims Digital Portal</axis-navbar-app-title>
    }
    <axis-navbar-right>
      <ul class="axis-nav">
        @if (
        step &&
        step['current'] &&
        step['current']['slNo'] === 1 &&
        (country === 'th' || country === 'vn')
        ) {
        <li class="axis-navbar-item _border-right _flex-row-reverse">
          <axis-button-toggle
            class="size-small"
            #smallBtn
            (getSelectedValue)="languageChange($event)"
            [(ngModel)]="selectedLanguage"
          >
            <axis-button-toggle-label
              [active]="true"
              [value]="'en'"
            >EN</axis-button-toggle-label>
            @if (country === 'vn') {
            <axis-button-toggle-label [value]="'vn'">VN</axis-button-toggle-label>
            }
            @if (country === 'th') {
            <axis-button-toggle-label [value]="'th'">TH</axis-button-toggle-label>
            }
          </axis-button-toggle>
        </li>
        }

      </ul>
    </axis-navbar-right>
  </axis-navbar>
  <nav
    axisStickyNew="60"
    axisStickyScrollUp="true"
    class="axis-navbar-mobile"
    [ngClass]="{
        open: navbarOpen,
        singapore_nav_header: country === 'singapore'
      }"
  >
    <div class="axis-mobile-overlay"></div>
    <div
      class="axis-mobile-header"
      [ngClass]="{ singapore_nav_header: country === 'singapore' }"
    >
      <div class="axis-navbar-title">
        <axis-navbar-logo>
          <img
            alt="AIG logo"
            src="assets/images/logos/aig-logo-blue.svg"
          />
          <span class="sr-only">American International Group, Inc.</span>
        </axis-navbar-logo>
        @if (country !== 'singapore' && country !== 'us') {
        <axis-navbar-app-title>Claims Digital Portal</axis-navbar-app-title>
        }
        <axis-navbar-right>
          <ul class="axis-nav">
            @if (country === 'sg') {
            <li class="axis-navbar-item">
              <img
                alt="Gojek logo"
                class="axis-img-responsive"
                src="assets/images/logos/gojek.png"
                templateClasses="axis-navbar-dropdown"
                width="80px"
              />
            </li>
            }
          </ul>
        </axis-navbar-right>
      </div>
    </div>
    <div
      class="axis-navbar-mobile-container"
      [ngClass]="{ open: navbarOpen }"
    ></div>
  </nav>
  }

  @if (FnolService.getPagestatus()) {
  <axis-navbar
    ariaLabel="Secondary Menu"
    *ngIf="screenSize !== 'mobile' "
  >
    <axis-navbar-logo>
      <img
        alt="AIG logo"
        src="assets/images/logos/aig-logo-blue.svg"
      />
      <span class="sr-only">American International Group, Inc.</span>
    </axis-navbar-logo>
    @if (languages === 'no') {
    <axis-navbar-app-title>Skademelding</axis-navbar-app-title>
    }
    @if (getCountryCode !== 'jp') {
    <axis-navbar-app-title>Claims Digital Portal</axis-navbar-app-title>
    }
    @if (getCountryCode === 'jp') {
    <axis-navbar-app-title i18n="@@appTitle">デジタル保険金請求</axis-navbar-app-title>
    }
  </axis-navbar>
  <nav
    class="axis-navbar-mobile"
    *ngIf="screenSize !== 'desktop'"
    [ngClass]="{'open':navbarOpen}"
  >
    <div class="axis-mobile-header">
      <div class="axis-navbar-title">
        <axis-navbar-logo>
          <img
            alt="AIG logo"
            src="assets/images/logos/aig-logo-blue.svg"
          />
          <span class="sr-only">American International Group, Inc.</span>
        </axis-navbar-logo>
        @if (languages === 'no') {
        <axis-navbar-app-title>Skademelding</axis-navbar-app-title>
        }
        @if (getCountryCode !== 'jp') {
        <axis-navbar-app-title>Claims Digital Portal</axis-navbar-app-title>
        }
        @if (getCountryCode === 'jp') {
        <axis-navbar-app-title i18n="@@appTitle">デジタル保険金請求</axis-navbar-app-title>
        }
      </div>
    </div>
  </nav>
  }
  <ng-template #templateCloseVar>
    <div class="axis-mobile-close-btn">
      <button
        axis-button
        class="kind-icon"
        (click)="toggleNavbar()"
        aria-label="close"
      >
        <axis-icon icon="cross"></axis-icon>
      </button>
    </div>
  </ng-template>
</header>
<modal-confirm #modalConfirm></modal-confirm>
<modal-contact #modalContact></modal-contact>